export type AssistantAmount = { currency: string; estimated: unknown; declared: unknown };

export function validAmount(value: unknown): boolean {
  return typeof value === 'string' && /^\d{1,12}(\.\d{1,2})?$/.test(value) && Number(value) <= 999999999999.99;
}

// Calculate the displayed preview in cents, without binary floating-point rounding.
export function previewTax(value: string, rate: unknown): number | null {
  if (!validAmount(value) || rate == null || !Number.isFinite(Number(rate)) || Number(rate) < 0 || Number(rate) > 1) return null;
  const [whole, fraction = ''] = value.split('.');
  const cents = BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'));
  const rateUnits = BigInt(Math.round(Number(rate) * 100000000));
  return Number((cents * rateUnits + 50000000n) / 100000000n) / 100;
}

export function declarationAmounts(detail: any, native: boolean): AssistantAmount[] {
  if (native) return [{ currency: detail.currency, estimated: detail.estimated_base, declared: detail.declared_base ?? detail.estimated_base }];
  const d = detail.declaration;
  const all = ['USD', 'CDF'].map(currency => ({ currency, estimated: d[`collected_${currency.toLowerCase()}`], declared: d[`declared_${currency.toLowerCase()}`] ?? d[`collected_${currency.toLowerCase()}`] }));
  // Historical declarations can contain two independent taxable amounts.
  // Never convert one into the other or discard a nonzero currency.
  const relevant = all.filter(a => a.estimated == null || a.declared == null || Number(a.estimated) !== 0 || Number(a.declared) !== 0);
  return relevant.length ? relevant : [all[0]];
}

export function sourceLabel(detail: any, native: boolean): string {
  const sources = native ? detail.source_snapshot : detail.sources?.data;
  if (!Array.isArray(sources) || !sources.length) return 'Source non renseignée';
  const names: Record<string, string> = {HOTEL_PORTAL: 'PMS / Hotel Portal', PMS: 'PMS', POS: 'POS', SDC: 'SDC', DIEF: 'DIEF', API: 'API enregistrée'};
  const labels = sources.map((s: any) => names[s.source] || (['stay', 'CHECKIN'].includes(s.kind) ? 'PMS / Hotel Portal' : 'Transactions enregistrées'));
  return [...new Set(labels)].join(' · ');
}
